import { render, staticRenderFns } from "./document-body.vue?vue&type=template&id=717ce548&scoped=true&"
import script from "./document-body.vue?vue&type=script&lang=js&"
export * from "./document-body.vue?vue&type=script&lang=js&"
import style0 from "./document-body.vue?vue&type=style&index=0&id=717ce548&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ce548",
  null
  
)

export default component.exports